/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const BlackTieIconConfig = {
  name: 'BlackTieIcon',
  height: 512,
  width: 448,
  svgPath: 'M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(BlackTieIconConfig);
//# sourceMappingURL=black-tie-icon.js.map